import { FormattedMessage, injectIntl } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import messages from './messages';
import './styles.css';
import Grid from '../../components/Grid';
import Radio from '../../components/Radio';

const Renewable = ({ intl, index, renewable, onChange }) => (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={3}>
        <b><FormattedMessage {...messages.meritScholarshipsRenewableLabel} /></b>
        <span styleName="required">&#x002a;</span>
      </Grid.Column>
      <Grid.Column width={4}>
        <Grid styleName="merit-scholarships-inner-grid">
          <Grid.Row styleName="merit-scholarships-inner-grid-row">
            <Radio
              key={`scholarship-key-radio-renewable-true-${index}`}
              data-cy="scholarship-key-radio-renewable-true"
              aria-label="Renewable scholarship"
              label={intl.formatMessage(messages.meritScholarshipsRenewableLabel)}
              name={`renewableRadioGroup-${index}`}
              checked={renewable === true}
              onChange={() => onChange({ target: { value: true } }, 'renewable')}
            />
          </Grid.Row>
          <Grid.Row styleName="merit-scholarships-inner-grid-row">
            <Radio
              key={`scholarship-key-radio-renewable-false-${index}`}
              data-cy="scholarship-key-radio-renewable-false"
              aria-label="One time scholarship"
              label={intl.formatMessage(messages.meritScholarshipsOneTimeLabel)}
              name={`renewableRadioGroup-${index}`}
              checked={renewable === false}
              onChange={() => onChange({ target: { value: false } }, 'renewable')}
            />
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
);

Renewable.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renewable: PropTypes.bool,
  onChange: PropTypes.func,
};

export default injectIntl(Renewable);
